import create from '../../creator'
import eventApi from '@/api/events'
import * as types from './mutation-types'

const initialState = () => ({
	eventTicket: {
		eventId: '',
		id: '',
		event: {},
		eventPurchaseOrder: {
			chargeInfo: {}
		},
		eventTicketMeta: {}
	}
})
const state = initialState()

const actions = {
	async getEventTicket({ commit }, data) {
		const resp = await eventApi.getEventTicket(data)

		commit(types.SET_EVENT_TICKET, resp.data)
	}
}

const mutations = {
	[types.SET_EVENT_TICKET](state, eventTicket) {
		state.eventTicket = eventTicket
	}
}

const getters = {
	eventTicketMeta: state => state.eventTicket.eventTicketMeta,
	chargeInfo: state => state.eventTicket.eventPurchaseOrder.chargeInfo,
	eventTicketId: state => state.eventTicket.id
}

export default create(
	{
		namespaced: true,
		state,
		actions,
		mutations,
		getters
	},
	initialState()
)
